<p-table [value]="groupedForecastData"  styleClass="p-datatable-sm" rowGroupMode="subheader" groupRowsBy="group">
  <ng-template pTemplate="header" >
      <tr>
          <th scope="col" class="metric-col">Model Outputs</th>
          <th scope="col" class="text-right year-col" *ngFor="let col of cols">{{ col }}</th>
      </tr>
  </ng-template>
  <ng-template pTemplate="groupheader" let-rowData>
      <tr pRowGroupHeader >
      </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
      <tr class="group_{{rowData['key'].group}}" [ngClass]="(rowData['key']?.displayNameStyles === 'bold' || (rowData.metric ==='realizedPCMoic')) ? 'border-top totals-background' :'' ">
          <td class="metric-col" [ngClass]="rowData['key']?.displayNameStyles">{{rowData.metric}}<span *ngIf="rowData['key']?.templated">*</span></td>
          <td class="text-right year-col" *ngFor="let year of cols" [style.color]="rowData[year]['displayColor']" [ngClass]="rowData['key']?.displayNameStyles">
              {{ (rowData[year]['value'] ==='0' || rowData[year]['value'] ==='0%'|| rowData[year]['value'] ==='0.0x' || rowData[year]['value'] ==='$0' || rowData[year]['value'] === null ) ? '-' :  rowData[year]['value'] }}</td>
      </tr>
      <tr *ngIf="isTemplateValue && ri === groupedForecastData.length - 1" class="templated-note-row">
        <td [attr.colspan]="cols.length + 1" class="templated-note">
            Values marked with * are sourced from the uploaded template and are not computed by Quilt.
          </td>
      </tr>
  </ng-template>
</p-table>
